// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICodePropertyDto
 */
export interface ICodePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof ICodePropertyDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ICodePropertyDto
     */
    code_state?: ICodePropertyDtoCodeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICodePropertyDtoCodeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ICodePropertyDto interface.
 */
export function instanceOfICodePropertyDto(value: object): value is ICodePropertyDto {
    return true;
}

export function ICodePropertyDtoFromJSON(json: any): ICodePropertyDto {
    return ICodePropertyDtoFromJSONTyped(json, false);
}

export function ICodePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICodePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'code_state': json['code_state'] == null ? undefined : json['code_state'],
    };
}

export function ICodePropertyDtoToJSON(json: any): ICodePropertyDto {
    return ICodePropertyDtoToJSONTyped(json, false);
}

export function ICodePropertyDtoToJSONTyped(value?: ICodePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'code_state': value['code_state'],
    };
}

